import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Position } from '@staffedupusa/shared-components';
import { InfoIcon } from '../../../../vectors/index';
import { useUpdateJobPosting } from '@features/jobPostings/hooks/useUpdateJobPosting';
import PlanName from '../PickPlanStep/PlanName';

interface ActiveJobsModalProps {
  open: boolean;
  handleClose: () => void;
  positions: Position[];
}

const ActiveJobsModal: React.FC<ActiveJobsModalProps> = ({
  open,
  positions,
  handleClose,
}) => {
  const navigate = useNavigate();
  const [errorText, setErrorText] = useState<string>('');

  const { updateJobPosting } = useUpdateJobPosting({
    refetch: true,
    setErrorText,
  });

  useEffect(() => {
    if (open) {
      positions?.forEach((position: Position) => {
        if (position.status !== 4) {
          updateJobPosting({
            id: position.id,
            status: 4,
          });
        }
      });
    }
  }, []);

  const handleCloseModal = () => {
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleCloseModal} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleCloseModal}
        >
          <Close />
        </IconButton>
        <br />
        <InfoIcon />
        <br />
        <PlanName planName="Starter" />
      </DialogTitle>
      <DialogContent sx={{ maxWidth: '400px', margin: 'auto' }}>
        <Typography color="GrayText" textAlign="center" mt={1} mb={1}>
          Your Starter Plan only allows for one job post. Make sure to head over
          to you Job Management page to select the job you’d like to post now!
        </Typography>
        <Typography variant="h4" textAlign="center" mt={2} mb={2}>
          Need to post more jobs?
        </Typography>
        <Typography color="GrayText" textAlign="center" mt={1} mb={1}>
          Upgrade to Smarter to post unlimited jobs and never struggle to hire
          again!
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{ padding: '0 20px 20px 20px', justifyContent: 'center' }}
      >
        <Button
          sx={{ width: '200px' }}
          variant="contained"
          onClick={() => {
            handleCloseModal();
            navigate('/employer/positions/', {state: { active: true }});
          }}
          color="primary"
        >
          Manage my Jobs
        </Button>
        <Button
          sx={{ width: '200px' }}
          variant="contained"
          onClick={() => {
            handleCloseModal();
            navigate('/employer/account#Manage-Billing');
          }}
          color="secondary"
        >
          Upgrade my Plan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActiveJobsModal;
